<template>
    <footer class="cr-p3">
        <span class="cr-pr2 cr-pl2 footer-text" data-testing="footer-text">{{t('FOOTER_TEXT', {thisYear})}} </span>
        <a :href='logoUrl' target='_blank' :aria-label="t('FOOTER_LINK_LABEL')" data-testing="footer-link">
            <img :src="logo" height="40" alt="" contain data-testing="footer-logo"/>
        </a>
    </footer>
</template>

<style scoped>
.footer-text
{
    color: var(--cr-text);
}
footer
{
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import Config from "../config";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const logoUrl = Config.HOMEPAGE_BASE_URL;
const logo = ref('');
const thisYear = new Date().getFullYear();

onMounted(() => 
{
    if (Config.IS_USCR) 
    {
        logo.value = '/uscr_logo.svg'
    }
    else 
    {
        logo.value = '/vacr_logo.svg'
    }
});
</script>